import { Endereco } from './../models/endereco';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CepService {

constructor(
  private http: HttpClient
) { }

httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Authorization: 'my-auth-token',
  }),
};

protected UrlService: string = environment.apiUrl;

buscaEndereco(cep: number): Observable<Endereco> {
        const url = `${this.UrlService}/Inscricao/PesquisarCEP/${cep}`;
        return this.http.get<any>(url, this.httpOptions).pipe(
            map(res => {
                const enderecoResponse = new Endereco();
                enderecoResponse.bairro = res[0].bairro;
                enderecoResponse.cidade = res[0].cidade;
                enderecoResponse.uf = res[0].uf;
                enderecoResponse.logradouro = res[0].logradouro;
                enderecoResponse.complemento = res[0].complemento;
                enderecoResponse.numero = res[0].numero;

                return enderecoResponse;
            })
        );
    }
}

